// https://shopify.dev/docs/api/ajax/reference/cart#post--locale-cart-addjs
export async function asyncAddToCart(items) {
    try {
        const path = window.Shopify.routes.root + 'cart/add.js'

        return await fetch(path, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ items })
        })

    } catch (err) {
        if (err.response?.status === 401) {
            window.location.reload()
            return
        }

        console.error(err)
        return err.response
    }
}
